// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite40: FC<Favorite40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M30.184 8.296a6.22 6.22 0 0 0-4.237-.049c-1.478.514-2.532 1.887-3.242 3.363a12.844 12.844 0 0 0-.92 2.643l-.009.04a1.3 1.3 0 0 1-2.553-.004v-.002l-.008-.035a11.483 11.483 0 0 0-.192-.744 12.825 12.825 0 0 0-.727-1.9c-.71-1.475-1.763-2.847-3.242-3.36a6.22 6.22 0 0 0-4.238.05c-.892.334-1.88.907-2.647 1.888-.752.962-1.366 2.413-1.37 4.646v.01l.008.09c.008.092.026.243.065.446.078.406.24 1.02.573 1.782.664 1.518 2.028 3.662 4.849 5.925a51.197 51.197 0 0 1 6.923 6.717 42.7 42.7 0 0 1 1.273 1.573 38.39 38.39 0 0 1 1.172-1.455c1.516-1.792 3.828-4.226 7.04-6.83 2.81-2.28 4.177-4.426 4.845-5.943a8.58 8.58 0 0 0 .578-1.778 4.675 4.675 0 0 0 .075-.535v-.01c-.005-2.229-.617-3.676-1.368-4.637-.766-.98-1.755-1.555-2.648-1.89Zm5.316 6.556 1.3.014v.015l-.001.024-.003.066a7.284 7.284 0 0 1-.12.9 11.178 11.178 0 0 1-.75 2.324c-.786 1.785-2.262 4.073-5.019 6.44l-.568.475c-3.07 2.49-5.268 4.806-6.691 6.49a32.904 32.904 0 0 0-1.567 1.992 18.68 18.68 0 0 0-.475.69l-.003.004-1.08 1.74-1.114-1.719-.004-.006-.022-.033-.097-.143c-.088-.128-.223-.32-.404-.567a37.905 37.905 0 0 0-1.647-2.072 48.616 48.616 0 0 0-6.569-6.372c-3.141-2.521-4.768-5-5.604-6.912a11.074 11.074 0 0 1-.743-2.333 7.257 7.257 0 0 1-.116-.906l-.003-.066v-.038c0-.001 0-.002 1.3-.007l-1.3.005v-.005c0-2.755.767-4.792 1.92-6.267C7.258 7.127 8.7 6.314 9.901 5.863l.366-.128a8.82 8.82 0 0 1 5.638.056l.228.084c2.193.853 3.556 2.738 4.366 4.329.838-1.645 2.268-3.605 4.594-4.413a8.82 8.82 0 0 1 5.638-.056l.366.128c1.202.453 2.642 1.265 3.782 2.723 1.152 1.474 1.92 3.51 1.92 6.266v.013l-1.3-.013Z" />
        </svg>
    );
};

export default Favorite40;
